import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
            浏览分类
          </h2>
          <p className="mt-2 text-sm text-foreground-500">按主题快速找到你需要的内容</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-5 md:p-6 rounded-lg bg-background-100 hover:bg-background-200/70 border border-background-200/60 hover:border-primary-200/50 transition-all cursor-pointer"
            >
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors shrink-0">
                  <i className={`${cat.icon} text-lg`}></i>
                </div>
                <div>
                  <h3 className="text-base font-medium text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {cat.name}
                  </h3>
                  <p className="mt-1 text-xs text-foreground-500 leading-relaxed">{cat.description}</p>
                  <span className="inline-block mt-2 text-xs text-foreground-400">
                    {cat.articleCount} 篇文章
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}